const IDLE_TIMEOUT_MINUTES = Number(process.env.REACT_APP_SESSION_IDLE_TIMEOUT_MINUTES) || 15;
const WARNING_MINUTES = Number(process.env.REACT_APP_SESSION_WARNING_MINUTES) || 2;

export const SESSION_TIMEOUT_CONFIG = {
    IDLE_TIMEOUT_MS: IDLE_TIMEOUT_MINUTES * 60 * 1000,
    WARNING_BEFORE_TIMEOUT_MS: WARNING_MINUTES * 60 * 1000,
    THROTTLE_MS: 1000,
    STORAGE_KEY: `${process.env.REACT_APP_PORTAL_NAME}-last-user-activity`,
    ACTIVITY_EVENTS: ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'wheel'] as const,
};
